import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SolicitudesConsultaService } from './solicitudes-consulta.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { RNTFuncionarioEntry } from 'src/app/shared/entrys/rnt-funcionario.entry';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { Router } from '@angular/router';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';
import { AccionesRntType } from 'src/app/shared/enumeraciones/acciones-rnt.enum';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { ModalSuspencionComponent } from 'src/app/components/core/layouts/modal-suspencion/modal-suspencion.component';
import { ModalCancelacionComponent } from 'src/app/components/core/layouts/modal-cancelacion/modal-cancelacion.component';
import { Subscription } from 'rxjs';
import { TipoSolicitud } from 'src/app/shared/enumeraciones/tipo-solicitud.enum';
import { AlertsService } from 'src/app/shared/services/alerts.service';
import { AlertType } from 'src/app/shared/models/alert.model';
import { EstablecimientoComercioService } from '../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { EstadosRnt } from 'src/app/shared/enumeraciones/estados-rnt.enum';
import { environment } from 'src/environments/environment';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { CamaraComercioEntry } from 'src/app/shared/entrys/camara-comercio';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';
import { RntService } from '../rnts/rnt.service';
import { ModalHistorialDetalleProcesoComponent } from 'src/app/components/core/layouts/modal-historial-detalle-proceso/modal-historial-detalle-proceso.component';
import { MensajesUsuario } from 'src/app/shared/enumeraciones/mensajes-usuario.enum';
import { IHeaderOrderModel } from 'src/app/components/core/layouts/tablas-order/tablas-order.component';
import { TipoOrdenamiento } from '../../administrador/notificaciones-correos-masivos/enviados/notificaciones-correos-masivos-enviados.component';


@Component({
	selector: 'app-solicitudes-consulta',
	templateUrl: './solicitudes-consulta.component.html',
	styleUrls: ['./solicitudes-consulta.component.scss']
})
export class SolicitudesConsultaComponent implements OnInit {
	datoSolicitudSharedModel: DatoSolicitudSharedModel;
	orderQuery: string = null;
	headers: IHeaderOrderModel[] = [];
	solicitudes: Array<RNTFuncionarioEntry>;
	formFiltroSolicitud: FormGroup;
	dataTabla: DatoPaginadoModel;
	tipos_solicitud: Array<any>;
	estados_solicitud: Array<any>;
	estados_rnt: Array<any>;
	suscripcion: Subscription;
	lista_rnt: string;
	tipo_inscripcion = TipoSolicitud.Inscripcion;
	estado_activo = EstadosRnt.Activo;
	camaraUrl: string;
	tipo_funcionario = RolesUsuario.Funcionario;
	adminSuper = RolesUsuario.AdministradorSuper;
	private rutaAmazon;
	userLogin: boolean;
	camarasLista: Array<CamaraComercioEntry>;
	soloConsultaNacional = RolesUsuario.SoloConsultaNacional;
	paginaActual: number;
	constructor(private formBuilder: FormBuilder, private router: Router,private rntService: RntService,
		private solicitudesService: SolicitudesConsultaService, public authService: AuthService,
		private dataSharedService: DataSharedService, private modalService: NgbModal, private alertService: AlertsService,
		private establecimientoComercioService: EstablecimientoComercioService, private enviromentGlobalService: EnviromentGlobalService) {
		this.initHeaders();
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
		this.suscripcion = this.dataSharedService.data$.subscribe(dataShared => {
			this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
		});
		this.userLogin = authService.isToken();
		this.paginaActual = 1;
		this.rutaAmazon = enviromentGlobalService.amazonImage;
	}
	onOrderModel(event: string){
		this.orderQuery = event;
		this.onPaginado(this.paginaActual);
	}
	initHeaders(): void{
		this.headers = [
			{
				column_name: 'P.NIT',
				label: 'Nit Del Propietario',
				current_order: TipoOrdenamiento.Ninguno,
				is_sortable: true
			},
			{
				column_name: 'E.RAZON_SOCIAL',
				label: 'Establecimiento',
				current_order: TipoOrdenamiento.Ninguno,
				is_sortable: true
			},
			{
				column_name: 'TR.DESCRIPCION',
				label: 'Tipo RNT',
				current_order: TipoOrdenamiento.Ninguno,
				is_sortable: true
			},
			{
				column_name: 'TS.DESCRIPCION',
				label: 'Tipo de solicitud',
				current_order: TipoOrdenamiento.Ninguno,
				is_sortable: true
			},
			{
				column_name: 'S.FECHA_CREACION',
				label: 'Fecha Radicación',
				current_order: TipoOrdenamiento.Ninguno,
				is_sortable: true
			},
			{
				column_name: '23',
				label: 'Fecha y hora del reingreso',
				current_order: TipoOrdenamiento.Ninguno,
				is_sortable: true
			},
			{
				column_name: 'R.CODIGO_RNT',
				label: 'Número RNT',
				current_order: TipoOrdenamiento.Ninguno,
				is_sortable: true
			},
			{
				column_name: 'E.MATRICULA',
				label: 'Matricula',
				current_order: TipoOrdenamiento.Ninguno,
				is_sortable: true
			},
			{
				column_name: 'DIAS_ATRASO',
				label: 'Vencimiento',
				current_order: TipoOrdenamiento.Ninguno,
				is_sortable: true
			},
			{
				column_name: '',
				label: 'Detalle Proceso',
				current_order: TipoOrdenamiento.Ninguno,
				is_sortable: false
			},
			{
				column_name: 'ER.DESCRIPCION',
				label: 'Estado RNT',
				current_order: TipoOrdenamiento.Ninguno,
				is_sortable: true
			},
			{
				column_name: 'S.NUMERO_RADICACION',
				label: 'Radicado',
				current_order: TipoOrdenamiento.Ninguno,
				is_sortable: true
			},
			{
				column_name: '',
				label: 'Acciones',
				current_order: TipoOrdenamiento.Ninguno,
				is_sortable: false
			}
	];
	}
	ngOnInit() {
		
		this.formFiltroSolicitud = this.formBuilder.group({
			nit: [null],
			matricula: [null],
			tipo_solicitud_id: [null],
			estado_rnt_id: [null],
			codigo_rnt: [null],
			asignado: [null],
			codigo_camara: [null],
			numero_radicacion: [null]
		});
		this.onSolicitudes();
		this.onEstadosSolicitudes();
		this.onEstadosRnt();
		this.onFiltrar();
		this.authService.logoCamaraUser.subscribe(resultado => {
			if (resultado.result) {
				this.camaraUrl = `${this.rutaAmazon}/${resultado.data.ruta}/${resultado.data.nombre_archivo}`;
			}
		});
		this.establecimientoComercioService.getCamaras().subscribe(resultado => {
			if (resultado) {
				this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
			}
		});
	}

	onFiltrar() {
		this.paginaActual = 1;
		this.solicitudesService.getSolicitudes(1,  {...this.formFiltroSolicitud.value,order_query:this.orderQuery}).subscribe(resultado => {
			if (resultado.result) {
				this.dataTabla = resultado.data as DatoPaginadoModel;
				this.solicitudes = this.dataTabla.items as Array<RNTFuncionarioEntry>;
			}
		});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.solicitudesService.getSolicitudes(value,  {...this.formFiltroSolicitud.value,order_query:this.orderQuery}).subscribe(resultado => {
			if (resultado.result) {
				this.dataTabla = resultado.data as DatoPaginadoModel;
				this.solicitudes = this.dataTabla.items as Array<RNTFuncionarioEntry>;
			}
		});
	}

	onAcciones(solicitudes: RNTFuncionarioEntry, accionRntType: AccionesRntType) {
		switch (accionRntType) {
			case AccionesRntType.DetalleSolicitud:
				this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
					data: solicitudes,
					tipo_rnt: solicitudes.tipo_rnt_id
				});
				this.router.navigate(['detalle-solicitud/establecimientos']);
				break;

			case AccionesRntType.Arrendatario:
				this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
					data: solicitudes
				});
				this.router.navigate(['arrendatario']);
				break;
		}
	}
	onReporte(rntPrestadorEntry: RNTPrestadorEntry) {
		this.establecimientoComercioService.getExpedirCertificadoRegistroPorRnt(rntPrestadorEntry).subscribe(resultado => {
			const url = window.URL.createObjectURL(resultado);
			window.open(url);
		});
	}
	onCertificado(rntPrestadorEntry: RNTPrestadorEntry) {
		this.establecimientoComercioService.getExpedirCertificadoPorRnt(rntPrestadorEntry)
			.subscribe(resultado => {
				const url = window.URL.createObjectURL(resultado);
				window.open(url);
			});
	}
	onAnotacion(rntPrestadorEntry: RNTPrestadorEntry) {
		this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
			data: rntPrestadorEntry,
			tipo_rnt: rntPrestadorEntry.tipo_rnt_id
		});
		this.router.navigate(['anotacion']);
	}
	get AccionesRntType() {
		return AccionesRntType;
	}

	onAccionesAsignar(solicitudes: RNTFuncionarioEntry) {
		this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
			data: solicitudes
		});
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = '¿Está seguro de asignarse la solicitud seleccionada?';
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.result.then(() => {
			this.solicitudesService.sendAsignacion(solicitudes).subscribe(result => {
				if (result.result) {
					this.onFiltrar();
				}
			});
		});
	}

	onSolicitudes() {
		this.solicitudesService.getTiposSolicitud().subscribe(resultado => {
			if (resultado.result) {
				this.tipos_solicitud = resultado.data;
			}
		});
	}

	onEstadosSolicitudes() {
		this.solicitudesService.getEstadosSolicitudes().subscribe(resultado => {
			if (resultado.result) {
				this.estados_solicitud = resultado.data;
			}
		});
	}

	onEstadosRnt() {
		this.solicitudesService.getEstadosRnt().subscribe(resultado => {
			if (resultado.result) {
				this.estados_rnt = resultado.data;
			}
		});
	}

	onOpenModalSuspencion() {
		const modalRef = this.modalService.open(ModalSuspencionComponent,
			{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop' });
		modalRef.result.then(resultado => {
			const modalRef_2 = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
			const confirmarRespuesta = {} as ConfirmarRespuestaModel;
			confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
			confirmarRespuesta.message = `¿Está seguro de suspender los establecimientos? Esta acción no se puede revertir`;
			modalRef_2.componentInstance.confirmarRespuesta = confirmarRespuesta;
			modalRef_2.result.then(() => {
				this.lista_rnt = '';
				resultado.forEach(item => {
					this.lista_rnt += `${item.rnt_id},`;
				});
				// tslint:disable-next-line:max-line-length
				this.solicitudesService.sendSuspencionMasiva({ lista_rnt: this.lista_rnt, tipo_solicitud_id: TipoSolicitud.Suspension }).subscribe(result => {
					if (result.result) {
						this.alertService.alert(result.control.alert_type as AlertType, 'La solicitud fue enviada exitosamente.',
							`/Solicitud/${this.lista_rnt}`,
							result.control.code.toString(), true);
					}
				});
			});
		});
	}

	onOpenModalCancelacion() {
		const modalRef = this.modalService.open(ModalCancelacionComponent,
			{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop' });
		modalRef.result.then(resultado => {
			const modalRef_2 = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
			const confirmarRespuesta = {} as ConfirmarRespuestaModel;
			confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
			confirmarRespuesta.message = `¿Está seguro de suspender los establecimientos? Esta acción no se puede revertir`;
			modalRef_2.componentInstance.confirmarRespuesta = confirmarRespuesta;
			modalRef_2.result.then(() => {
				this.lista_rnt = '';
				resultado.forEach(item => {
					this.lista_rnt += `${item.rnt_id},`;
				});
				// tslint:disable-next-line:max-line-length
				this.solicitudesService.sendSuspencionMasiva({ lista_rnt: this.lista_rnt, tipo_solicitud_id: TipoSolicitud.Cancelacion }).subscribe(result => {
					if (result.result) {
						this.alertService.alert(result.control.alert_type as AlertType, 'La solicitud fue enviada exitosamente.',
							`/Solicitud/${this.lista_rnt}`,
							result.control.code.toString(), true);
					}
				});
			});
		});
	}

	reset() {
		this.formFiltroSolicitud.reset();
		this.onFiltrar();
	}

	modalDetalleProceso(rntId){
		this.rntService.historialDetalleProceso(rntId).subscribe((response) => {
		  if(response.result){
			const modalRef = this.modalService.open(
				ModalHistorialDetalleProcesoComponent,
				{
				  centered: true,
				  size: "lg",
				  backdropClass: "light-blue-backdrop",
				}
			  );
			modalRef.componentInstance.rntId = rntId;
		  } else{
			this.alertService.error(
			  MensajesUsuario.Errorgeneral,
			  null,
			  null
			);
		  }
		});	 
	}
}
